<template>
  <b-form autocomplete="off">
    <!-- THONG TIN CHUNG -->
    <b-form-row>
      <b-col cols="12" md="6" style="padding-left:15px; padding-right:70px;">
        <b-form-group label-cols="3">
          <template v-slot:label>
            Employee Picture
            <!-- Ảnh nhân viên -->
          </template>
          <div v-if="thong_tin_chung.anhnhanvien == null">
            <i class="fas fa-user"></i>
          </div>
          <div v-else>
            <img
              :src="thong_tin_chung.anhnhanvienpath"
              style="max-width: 150px;"
            />
          </div>
          <div v-if="hoso_update">
            <a
              v-if="thong_tin_chung.anhnhanvien == null"
              href="#"
              @click.prevent="uploadImageShow = true"
            >
              Choose Picture
              <!-- Chọn ảnh -->
            </a>
            <a v-else href="#" @click.prevent="clearItemImage">
              Delete Picture
              <!-- Xóa ảnh -->
            </a>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
        style="padding-left:70px; padding-right:15px;"
        class="form-inline"
        v-if="item"
        align-self="start"
      >
        <div style="flex-grow: 1" />
        <button
          class="btn btn-info"
          @click.prevent="updateThongTinChung"
          v-if="hoso_update"
        >
          <i class="fas fa-save mr-2"></i>
          Save General Information
          <!-- Lưu thông tin chung -->
        </button>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="6" style="padding-left:15px; padding-right:70px;">
        <b-form-group label-cols="3">
          <template v-slot:label>
            Email
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            v-model="thong_tin_chung.email"
            type="email"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Employee ID
            <!-- Mã nhân viên -->
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            v-model="thong_tin_chung.manhanvien"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Name
            <!-- Họ và tên -->
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            v-model="thong_tin_chung.hovaten"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            English Name
            <!-- Tên tiếng anh -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.tentienganh"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Gender
            <!-- Giới tính -->
          </template>
          <b-form-select
            :disabled="!hoso_update"
            v-model="thong_tin_chung.gioitinh"
            :options="optionsGioiTinh"
            value-field="text"
            text-field="text"
          ></b-form-select>
        </b-form-group>
        <b-form-group label-cols="3" style="margin-bottom: 0;">
          <template v-slot:label>
            Date of birth
            <!-- Ngày sinh -->
          </template>
          <my-date-picker
            :disabled="!hoso_update"
            v-model="ngaysinh_selected"
          ></my-date-picker>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Place of birth
            <!-- Nơi sinh -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.noisinh"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="12">
          <template v-slot:label>
            <div class="form-inline">
              <b class="mr-4">
                Line Manager
                <!-- Line Manager -->
              </b>
            </div>
          </template>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Name
            <span class="text-danger" v-if="!nolinemanager">*</span>
            <!-- Line manager -->
          </template>
          <multiselect
            v-model="linemanager_selected"
            placeholder
            track-by="id"
            label="hovaten"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :disabled="nolinemanager"
            :searchable="true"
            :options="linemanagers"
            @select="unlockLineManager"
            @remove="lockLineManager"
          >
          </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            CC email
          </template>
          <b-form-input
            v-model="employee_group.ccemail"
            :disabled="!ccEmailEnabled"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <!-- <b-col cols="0" md="1" /> -->
      <b-col cols="12" md="6" style="padding-left:70px; padding-right:15px;">
        <b-form-group v-if="item" label-cols="3">
          <template v-slot:label>
            Working Status
            <!-- Trạng thái -->
          </template>
          <b-form-select
            v-if="!nghiviecdate_show"
            :disabled="!hoso_update"
            style="width:100%"
            v-model="thong_tin_chung.tinhtranghoso"
            :options="tinhtranghosos"
            value-field="id"
            text-field="pickListValue"
            @change="trangthaiChange"
          ></b-form-select>
          <b-row v-else>
            <b-col cols="6">
              <b-form-select
                :disabled="!hoso_update"
                style="width:100%"
                v-model="thong_tin_chung.tinhtranghoso"
                :options="tinhtranghosos"
                value-field="id"
                text-field="pickListValue"
                @change="trangthaiChange"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <my-date-picker v-model="ngaynghiviec_selected"></my-date-picker>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group v-if="item" label-cols="3">
          <template v-slot:label>
            Company
            <!-- Đơn vị công tác -->
          </template>
          <b-form-input
            :value="
              thong_tin_chung.employeeContract == null
                ? ''
                : findFirstDepartment(
                    departments,
                    thong_tin_chung.employeeContract.donvicongtac
                  )
            "
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="item" label-cols="3">
          <template v-slot:label>
            Position
            <!-- Vị trí công việc -->
          </template>
          <b-form-input
            :value="
              thong_tin_chung.employeeContract == null
                ? ''
                : findFirst(
                    vitricongviecs,
                    thong_tin_chung.employeeContract.vitricongviec
                  )
            "
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="item" label-cols="3">
          <template v-slot:label>
            Probation Date
            <!-- Ngày thử việc -->
          </template>
          <vue-datepicker-local
            disabled
            style="width: 100%"
            v-model="thong_tin_chung.ngaythuviec"
            :local="local"
            clearable
            format="DD/MM/YYYY"
          />
        </b-form-group>
        <b-form-group v-if="item" label-cols="3">
          <template v-slot:label>
            Working Date
            <!-- Ngày chính thức -->
          </template>
          <vue-datepicker-local
            disabled
            style="width: 100%"
            v-model="thong_tin_chung.ngaychinhthuc"
            :local="local"
            clearable
            format="DD/MM/YYYY"
          />
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            National
            <!-- Dân tộc -->
          </template>
          <div class="form-inline">
            <b-form-select
              :disabled="!hoso_update"
              style="width:100%"
              v-model="thong_tin_chung.dantoc"
              :options="dantocs"
              value-field="id"
              text-field="pickListValue"
            ></b-form-select>
            <!-- Bo nut button them Dantoc trong Edit
              <button class="btn" @click.prevent="openModal('dantoc')" v-if="hoso_update">
              <i class="fas fa-table"></i>
            </button> -->
          </div>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Religion
            <!-- Tôn giáo -->
          </template>
          <div class="form-inline">
            <b-form-select
              :disabled="!hoso_update"
              style="width:100%"
              v-model="thong_tin_chung.tongiao"
              :options="tongiaos"
              value-field="id"
              text-field="pickListValue"
            />
            <!-- Bo nut them TonGiao trong Edit
              <button class="btn" @click.prevent="openModal('tongiao')" v-if="hoso_update">
              <i class="fas fa-table"></i>
            </button> -->
          </div>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Nationality
            <!-- Quốc tịch -->
          </template>
          <div class="form-inline">
            <b-form-select
              :disabled="!hoso_update"
              style="width:calc(100% - 42px)"
              v-model="thong_tin_chung.quoctich"
              :options="quoctichs"
              value-field="id"
              text-field="pickListValue"
            />
            <button
              class="btn"
              @click.prevent="openModal('quoctich')"
              v-if="hoso_update"
            >
              <i class="fas fa-table"></i>
            </button>
          </div>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="6" style="padding-left:15px; padding-right:70px;">
        <b-form-group label-cols="12">
          <template v-slot:label>
            <b>
              PIT, SSI, Bank Info
              <!-- Tài khoản -->
            </b>
          </template>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            PIT code
            <!-- MST cá nhân -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.mstcanhan"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Social Insurance Book No.
            <!-- Số BHXH -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.sobhxh"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Bank Account No.
            <!-- Số tài khoản NH -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.sotaikhoannganhang"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Bank
            <!-- Ngân hàng -->
          </template>
          <!-- <b-form-input v-model="thong_tin_chung.nganhang" :readonly="!hoso_update"></b-form-input> -->
          <b-form-select
            v-model="thong_tin_chung.nganhang"
            :readonly="!hoso_update"
            text-field="name"
            value-field="name"
            :options="banks"
          ></b-form-select>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Bank Branch
            <!-- Chi nhánh -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.chinhanh"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <span style="padding-left: 5px; font-weight: 500;"
          >Initiaing Facility Registration</span
        >
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            City
            <!-- Thành phố -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_tinhthanhpho" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            :disabled="!hoso_update"
            v-model="hopital_city_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="hopitalCityProvinces"
            @select="unlockHopitalCity"
            @remove="lockHopitalCity"
          >
          </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Hopital Branch
            <!-- Chi nhánh -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.hopitalBranch"
            :disabled="!hopitalBranchEnabled"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <!-- <b-col cols="0" md="1" /> -->
      <b-col cols="12" md="6" style="padding-left:70px; padding-right:15px;">
        <b-form-group label-cols="12">
          <template v-slot:label>
            <b>
              ID Card/Passport
              <!-- CMND/Thẻ căn cước/Hộ chiếu -->
            </b>
          </template>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            ID/Passport No.
            <!-- Số -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.cmndso"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3" style="margin-bottom: 0;">
          <template v-slot:label>
            Issued Date
            <!-- Ngày cấp -->
          </template>
          <my-date-picker
            :disabled="!hoso_update"
            v-model="cmndngaycap_selected"
          ></my-date-picker>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Issued Place
            <!-- Nơi cấp -->
          </template>
          <b-form-input
            v-model="thong_tin_chung.cmndnoicap"
            :readonly="!hoso_update"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3" style="margin-bottom: 0;">
          <template v-slot:label>
            Expired Date
            <!-- Ngày hết hạn -->
          </template>
          <my-date-picker
            :disabled="!hoso_update"
            v-model="cmndngayhethan_selected"
          ></my-date-picker>
        </b-form-group>
      </b-col>
    </b-form-row>
    <!-- END OF THONG TIN CHUNG -->

    <!-- THONG TIN LIEN HE -->
    <b-form-row>
      <b-col
        cols="12"
        md="12"
        style="padding-left:15px; padding-right:15px;"
        class="form-inline"
        v-if="item"
        align-self="start"
      >
        <div style="flex-grow: 1" />
        <button
          v-if="hoso_update"
          class="btn btn-info"
          @click.prevent="updateThongTinLienHe"
        >
          <i class="fas fa-save mr-2"></i>
          Save Contact Information
          <!-- Lưu thông tin liên hệ -->
        </button>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="6" style="padding-left:15px; padding-right:70px;">
        <b-form-group label-cols="12">
          <template v-slot:label>
            <b>
              Place of birth
              <!-- Hộ khẩu thường trú -->
            </b>
          </template>
        </b-form-group>
      </b-col>
      <!-- <b-col cols="0" md="1" /> -->
      <b-col cols="12" md="6" style="padding-left:70px; padding-right:15px;">
        <b-form-group label-cols="12">
          <template v-slot:label>
            <div class="form-inline">
              <b class="mr-4">
                Contact address
                <!-- Chỗ ở hiện nay -->
              </b>
              <b-form-checkbox
                :disabled="!hoso_update"
                v-model="cbx_hien_nay_giong_ho_khau"
                @change="copySlot"
              >
                Same as Permanent Residence
                <!-- Giống hộ khẩu thường trú -->
              </b-form-checkbox>
            </div>
          </template>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="6" style="padding-left:15px; padding-right:70px;">
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            City
            <!-- Thành phố -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_tinhthanhpho" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            :disabled="!hoso_update"
            v-model="hokhau_tinhthanhpho_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="provinces"
            @select="unlockDistrict"
            @remove="lockDistrictAndWard"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            District
            <!-- Quận/Huyện -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_quanhuyen" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hokhau_quanhuyen_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="districts"
            @select="unlockWard"
            @remove="lockWard"
            :disabled="!districtEnabled"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            Ward
            <!-- Xã/Phường -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_xaphuong" :disabled="!hoso_update" ></b-form-input>         -->
          <multiselect
            v-model="hokhau_xaphuong_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="wards"
            :disabled="!wardEnabled"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            Address
            <!-- Số nhà, đường -->
          </template>
          <b-form-input v-model="thong_tin_lien_he.hokhau_sonha"></b-form-input>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            Phone Number
            <!-- ĐT di động -->
          </template>
          <b-form-input v-model="thong_tin_lien_he.dtdidong"></b-form-input>
        </b-form-group>
      </b-col>
      <!-- <b-col cols="0" md="1" /> -->
      <b-col cols="12" md="6" style="padding-left:70px; padding-right:15px;">
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            City
            <!-- Thành phố -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_tinhthanhpho" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hiennay_tinhthanhpho_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="provinces"
            @select="unlockDistrict_hiennay"
            @remove="lockDistrictAndWard_hiennay"
            :disabled="cbx_hien_nay_giong_ho_khau"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            District
            <!-- Quận/Huyện -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_quanhuyen" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hiennay_quanhuyen_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="hiennay_districts"
            @select="unlockWard_hiennay"
            @remove="lockWard_hiennay"
            :disabled="!hiennay_districtEnabled || cbx_hien_nay_giong_ho_khau"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            Ward
            <!-- Xã/Phường -->
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_xaphuong" :disabled="!hoso_update" ></b-form-input>         -->
          <multiselect
            v-model="hiennay_xaphuong_selected"
            placeholder
            track-by="id"
            label="name"
            selectedLabel="are selecting"
            select-label="Enter to select"
            deselectLabel="Enter to remove"
            :searchable="true"
            :options="hiennay_wards"
            :disabled="!hiennay_wardEnabled || cbx_hien_nay_giong_ho_khau"
          >
          </multiselect>
        </b-form-group>
        <b-form-group :disabled="!hoso_update" label-cols="3">
          <template v-slot:label>
            Address
            <!-- Số nhà, đường -->
          </template>
          <b-form-input
            v-model="thong_tin_lien_he.hiennay_sonha"
            :disabled="cbx_hien_nay_giong_ho_khau"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row> </b-form-row>
    <!-- END OF THONG TIN LIEN HE -->

    <!-- GIA DINH -->
    <b-form-row>
      <b-col
        cols="12"
        md="12"
        style="padding-left:15px; padding-right:15px;"
        class="form-inline"
        v-if="item"
        align-self="start"
      >
        <div style="flex-grow: 1" />
        <button
          class="btn btn-info mb-2"
          @click.prevent="openFamilyModal"
          v-if="hoso_update"
        >
          <i class="fas fa-plus"></i>
          Add
          <!-- Thêm -->
        </button>
      </b-col>
    </b-form-row>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(hovaten)="data" v-if="hoso_update">
        <b-link href="#" @click.prevent="openUpdateFamilyModal(data)">{{
          data.value
        }}</b-link>
      </template>
      <template v-slot:cell(ngaysinh)="data">{{
        data.item.ngaysinh | moment("DD/MM/YYYY")
      }}</template>
      <template v-slot:cell(thoidiemtinhgiamtru)="data">{{
        data.item.thoidiemtinhgiamtru | moment("DD/MM/YYYY")
      }}</template>
      <template v-slot:cell(phuthuoc)="data">
        <template v-if="data.item.phuthuoc">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template v-slot:cell(quanhe)="data">{{
        quanhes.find((x) => x.id === data.item.quanhe).pickListValue
      }}</template>
      <template v-slot:cell(action)="data" v-if="hoso_update">
        <b-link
          class="text-primary mr-2"
          href="#"
          @click="openUpdateFamilyModal(data)"
        >
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        <b-link
          class="text-danger"
          href="#"
          @click.prevent="deleteFamilyItem(data)"
        >
          <i class="fas fa-trash"></i>
        </b-link>
        <!-- <button class="btn btn-info mr-2" @click="openUpdateFamilyModal(data)">
          <i class="fas fa-eye"></i>
        </button>-->
        <!-- <button class="btn btn-danger" @click="deleteFamilyItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button> -->
      </template>
    </b-table>
    <b-modal
      v-model="modalFamilyShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="gia_dinh_item.id <= 0">
          Add family information
          <!-- Thêm thông tin gia đình -->
        </div>
        <div v-else>
          Update family information
          <!-- Update thông tin gia đình -->
        </div>
      </template>
      <b-form autocomplete="off">
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">
              Name
              <!-- Họ và tên -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-input
              v-model="gia_dinh_item.hovaten"
              required
            ></b-form-input>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              Relationship
              <!-- Quan hệ -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="gia_dinh_item.quanhe"
              :options="quanhes"
              value-field="id"
              text-field="pickListValue"
            />
          </b-col>
          <b-col cols="1">
            <button class="btn" @click.prevent="openModal('quanhe')">
              <i class="fas fa-table"></i>
            </button>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">
              Year of Birth
              <!-- Năm sinh -->
            </label>
          </b-col>
          <b-col cols="3">
            <b-form-input
              v-model="gia_dinh_item.namsinh"
              type="number"
            ></b-form-input>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              Phone Number
              <!-- Điện thoại -->
            </label>
          </b-col>
          <b-col cols="3">
            <b-form-input
              v-model="gia_dinh_item.dienthoai"
              required
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">
              Address
              <!-- Địa chỉ -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="gia_dinh_item.diachi"
              required
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2"></b-col>
          <b-col cols="9">
            <b-form-checkbox v-model="gia_dinh_item.phuthuoc">
              Is dependent
              <!-- Là người phụ thuộc -->
            </b-form-checkbox>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="12" class="form-inline">
            <div style="flex-grow: 1"></div>
            <b-button
              class="mr-3"
              variant="info"
              @click.prevent="storeFamilyItem"
            >
              <i class="fas fa-save mr-2"></i>
              Save
              <!-- Lưu -->
            </b-button>
            <b-button variant="secondary" @click="closeFamilyModal">
              <i class="fas fa-times mr-2"></i>
              Close
              <!-- Đóng -->
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <!-- END OF GIA DINH -->
    <b-modal
      v-model="uploadImageShow"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>Chọn ảnh</template>
      <div class="d-block text-center">
        <div>
          <img v-if="isImageUploading == true" src="../../assets/loading.gif" />
          <b-card v-if="isImageUploading == false" no-body>
            <div class="text-center p-2">
              <label for="uploadFile" style="width: 100%;">
                <h4 class="pt-2">
                  Nhấn vào đây để tải ảnh.
                  <br />hoặc
                </h4>
                <span
                  class="btn btn-primary file-uploads file-uploads-html5 file-uploads-drop"
                >
                  Chọn tập tin
                  <label for="uploadFile"></label>
                  <input
                    type="file"
                    name="uploadFile"
                    id="uploadFile"
                    accept="image/*"
                    @change="
                      fileChange($event.target.name, $event.target.files)
                    "
                  />
                </span>
              </label>
            </div>
          </b-card>
        </div>
      </div>
    </b-modal>
    <!-- <pickup-list-modal :items="modalItems" :type="modalType" :show="show" v-on:modalOk="modalOk" v-on:modalCancel="modalCancel"/> -->
  </b-form>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyDatePicker from "../App/MyDatePicker";
// // import the component
// import Treeselect from "@riophae/vue-treeselect";
// // import the styles
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "ThongTinChung",
  components: {
    Multiselect,
    VueDatepickerLocal,
    MyDatePicker,
    // Treeselect,
  },
  props: [
    "dantocs",
    "tongiaos",
    "quoctichs",
    "departments",
    "vitricongviecs",
    "item",
    "tinhtranghosos",
    "quanhes",
    "banks",
    "linemanagers",
    "nolinemanager",
  ],
  data() {
    return {
      // THONG TIN CHUNG DATA
      thong_tin_chung: {
        userid: 0,
        anhnhanvien: null,
        email: null,
        manhanvien: null,
        hovaten: null,
        tentienganh: null,
        // gioitinh: "Nam",
        gioitinh: "Male",
        ngaysinh: null,
        noisinh: null,
        tinhtranglamviec: null,
        hopitalCity: null,
        hopitalBranch: null,
        donvicongtac: null,
        vitricongviec: null,
        ngaythuviec: null,
        ngaychinhthuc: null,
        dantoc: null,
        tongiao: null,
        quoctich: null,
        tinhtranghoso: null,
        mstcanhan: null,
        sobhxh: null,
        sotaikhoannganhang: null,
        nganhang: null,
        chinhanh: null,
        cmndso: null,
        cmndngaycap: null,
        cmndnoicap: null,
        cmndngayhethan: null,
        salt: "test",
        password: "test",
        ngaynghiviec: null,
      },
      employee_group: {
        id: 0,
        employeeid: 0,
        employeeid2: null,
        groupid: 138,
        ccemail: null,
      },

      optionsGioiTinh: [
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        // { value: 1, text: "Nam" },
        // { value: 2, text: "Nữ" },
      ],
      optionsDanToc: [],
      optionsTonGiao: [],
      optionsQuocTich: [],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      ngaysinh_selected: "",
      cmndngaycap_selected: "",
      cmndngayhethan_selected: "",
      ngaynghiviec_selected: "",

      nghiviecdate_show: false,

      //Upload ảnh
      uploadImageShow: false,
      isImageUploading: false,

      // THONG TIN LIEN HA DATA
      thong_tin_lien_he: {
        id: 0,
        employeeid: 0,
        dtdidong: null,
        hokhau_tinhthanhpho: null,
        hokhau_quanhuyen: null,
        hokhau_xaphuong: null,
        hokhau_sonha: null,
        hiennay_tinhthanhpho: null,
        hiennay_quanhuyen: null,
        hiennay_xaphuong: null,
        hiennay_sonha: null,
      },

      hopitalCityProvinces: [],
      hopitalCityDistricts: [],

      hopitalBranchEnabled: false,
      ccEmailEnabled: false,

      hopital_city_selected: null,
      linemanager_selected: null,
      linemanager_temp_selected: null,

      provinces: [],
      districts: [],
      wards: [],

      districtEnabled: false,
      wardEnabled: false,

      hokhau_tinhthanhpho_selected: null,
      hokhau_quanhuyen_selected: null,
      hokhau_xaphuong_selected: null,

      hiennay_provinces: [],
      hiennay_districts: [],
      hiennay_wards: [],

      hiennay_provinceEnabled: false,
      hiennay_districtEnabled: false,
      hiennay_wardEnabled: false,
      hiennay_tinhthanhpho_selected: null,
      hiennay_quanhuyen_selected: null,
      hiennay_xaphuong_selected: null,

      cbx_hien_nay_giong_ho_khau: false,

      // GIA DINH
      modalFamilyShow: false,
      items: [],
      itemIdex: null,
      fields: [
        {
          key: "hovaten",
          label: "Name",
          // label: "Họ và tên",
        },
        {
          key: "namsinh",
          label: "Year of Birth",
          // label: "Năm sinh",
        },
        {
          key: "quanhe",
          label: "Relationship",
          // label: "Quan hệ",
        },
        {
          key: "dienthoai",
          label: "Phone Number",
          // label: "Điện thoại",
        },
        {
          key: "diachi",
          label: "Note",
          // label: "Địa chỉ",
        },
        {
          key: "phuthuoc",
          label: "Is dependent",
          // label: "Là người phụ thuộc",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "75px !important" },
        },
      ],
      gia_dinh_new: {
        id: 0,
        employeeid: 0,
        hovaten: null,
        quanhe: null,
        namsinh: null,
        dienthoai: null,
        diachi: null,
        phuthuoc: null,
      },
      gia_dinh_item: {
        id: 0,
        employeeid: 0,
        hovaten: null,
        quanhe: null,
        namsinh: null,
        dienthoai: null,
        diachi: null,
        phuthuoc: null,
      },
    };
  },

  watch: {
    linemanager_selected: function(newValue, oldValue) {
      if (newValue != null) {
        // if (this.employee_group.ccemail == null)
        // this.employee_group.ccemail = "hr@megroup.asia";
        this.employee_group.employeeid2 = newValue.id;
      } else {
        this.employee_group.employeeid2 = null;
        // this.employee_group.ccemail = null;
      }
    },
  },

  computed: {
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
  },
  created() {
    this.initData();
  },
  methods: {
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    normalizer(node) {
      if (node.childs != null) {
        return {
          id: node.id,
          label: node.tendonvi,
          children: node.childs,
        };
      } else {
        return {
          id: node.id,
          label: node.tendonvi,
        };
      }
    },
    initData() {
      if (this.item != null) {
        axios
          .all([
            axios.get(`/api/employee/${this.item.manhanvien}`),
            axios.get(`/api/employeecontact/${this.item.id}`),
            axios.get(`/api/employeefamily/${this.item.id}`),
          ])
          .then(
            axios.spread((thongtinchung, thongtinlienhe, giadinh) => {
              this.thong_tin_chung = thongtinchung.data.employee;
              this.thong_tin_lien_he = thongtinlienhe.data;
              this.items = giadinh.data;
              if (this.thong_tin_chung.employeeGroup != null) {
                this.employee_group = this.thong_tin_chung.employeeGroup;
                this.linemanager_selected = this.findLineManager(
                  this.linemanagers,
                  this.thong_tin_chung.employeeGroup.employeeid2
                );
                this.ccEmailEnabled = true;
              }
              this.ngaysinh_selected = this.$convert_date_string(
                this.thong_tin_chung.ngaysinh
              );

              this.cmndngaycap_selected = this.$convert_date_string(
                this.thong_tin_chung.cmndngaycap
              );
              this.cmndngayhethan_selected = this.$convert_date_string(
                this.thong_tin_chung.cmndngayhethan
              );

              if (
                this.thong_tin_chung.tinhtranghoso ==
                this.$tinhtranghoso_nghiviec
              ) {
                this.ngaynghiviec_selected = this.$convert_date_string(
                  this.thong_tin_chung.ngaynghiviec
                );
                this.nghiviecdate_show = true;
              }

              axios.get("/api/location/province").then((res) => {
                this.hopitalCityProvinces = res.data;
                this.hopital_city_selected = this.hopitalCityProvinces.find(
                  (x) => x.id == this.thong_tin_chung.hopitalCity
                );
                this.provinces = res.data;
                this.hokhau_tinhthanhpho_selected = this.provinces.find(
                  (x) => x.id == this.thong_tin_lien_he.hokhau_tinhthanhpho
                );
                this.hiennay_provinces = res.data;
                this.hiennay_tinhthanhpho_selected = this.hiennay_provinces.find(
                  (x) => x.id == this.thong_tin_lien_he.hiennay_tinhthanhpho
                );
              });

              if (this.thong_tin_chung.hopitalCity != null) {
                this.hopitalBranchEnabled = true;
              }
              if (this.thong_tin_lien_he.hokhau_tinhthanhpho != null) {
                axios
                  .get(
                    `/api/location/district/${this.thong_tin_lien_he.hokhau_tinhthanhpho}`
                  )
                  .then((res) => {
                    this.districts = res.data;
                    this.hokhau_quanhuyen_selected = this.districts.find(
                      (x) => x.id == this.thong_tin_lien_he.hokhau_quanhuyen
                    );
                  });

                this.districtEnabled = true;
              }

              if (this.thong_tin_lien_he.hokhau_quanhuyen != null) {
                axios
                  .get(
                    `/api/location/ward/${this.thong_tin_lien_he.hokhau_quanhuyen}`
                  )
                  .then((res) => {
                    this.wards = res.data;
                    this.hokhau_xaphuong_selected = this.wards.find(
                      (x) => x.id == this.thong_tin_lien_he.hokhau_xaphuong
                    );
                  });

                this.wardEnabled = true;
              }

              // axios.get("/api/location/province").then((res) => {
              //   this.hiennay_provinces = res.data;
              //   this.hiennay_tinhthanhpho_selected = this.hiennay_provinces.find(
              //     (x) => x.id == this.thong_tin_lien_he.hiennay_tinhthanhpho
              //   );
              // });

              if (this.thong_tin_lien_he.hiennay_tinhthanhpho != null) {
                axios
                  .get(
                    `/api/location/district/${this.thong_tin_lien_he.hiennay_tinhthanhpho}`
                  )
                  .then((res) => {
                    this.hiennay_districts = res.data;
                    this.hiennay_quanhuyen_selected = this.hiennay_districts.find(
                      (x) => x.id == this.thong_tin_lien_he.hiennay_quanhuyen
                    );
                  });

                this.hiennay_districtEnabled = true;
              }

              if (this.thong_tin_lien_he.hiennay_quanhuyen != null) {
                axios
                  .get(
                    `/api/location/ward/${this.thong_tin_lien_he.hiennay_quanhuyen}`
                  )
                  .then((res) => {
                    this.hiennay_wards = res.data;
                    this.hiennay_xaphuong_selected = this.hiennay_wards.find(
                      (x) => x.id == this.thong_tin_lien_he.hiennay_xaphuong
                    );
                  });

                this.hiennay_wardEnabled = true;
              }
            })
          );
      }
    },

    openModal(modalType) {
      this.$emit("openModal", modalType);
    },
    fileChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.isImageUploading = true;
      const formData = new FormData();
      formData.append("file", fileList[0]);
      axios
        .post("/api/employee/uploadimage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.thong_tin_chung.anhnhanvien = res.data.filename;
          this.thong_tin_chung.anhnhanvienpath = res.data.filepath;
          this.isImageUploading = false;
          this.uploadImageShow = false;
        })
        .catch((err) => {
          alert(err);
        });
    },
    clearItemImage() {
      this.thong_tin_chung.anhnhanvien = this.thong_tin_chung.anhnhanvienpath = null;
    },
    updateThongTinChung() {
      if (
        !(
          this.thong_tin_chung.manhanvien &&
          this.thong_tin_chung.manhanvien.length
        ) ||
        !(this.thong_tin_chung.hovaten && this.thong_tin_chung.hovaten.length)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin!", "Error", {
          //Please enter complete information!
          timeout: 2000,
        });
      } else if (!this.employee_group.employeeid2 && !this.nolinemanager) {
        this.$toast.error("Vui lòng chọn Line Manager!", "Error", {
          //Please select Line Manager!
          timeout: 2000,
        });
      } else {
        if (this.employee_group.ccemail != null) {
          var ccemail_err = this.CheckCCEmail(
            this.employee_group.ccemail.trim().trim(",")
          );
          if (ccemail_err != "") {
            this.$toast.error(
              `CC Email không đúng định dạng [${ccemail_err}]!`, //CC Email is not in correct format
              "Error",
              {
                timeout: 2000,
              }
            );
            return;
          }
        }
        this.thong_tin_chung.ngaysinh = this.$convert_string_GMT7_DateTime(
          this.ngaysinh_selected
        );
        this.thong_tin_chung.cmndngaycap = this.$convert_string_GMT7_DateTime(
          this.cmndngaycap_selected
        );

        this.thong_tin_chung.cmndngayhethan = this.$convert_string_GMT7_DateTime(
          this.cmndngayhethan_selected
        );

        this.thong_tin_chung.ngaynghiviec = this.$convert_string_GMT7_DateTime(
          this.ngaynghiviec_selected
        );

        if (this.hopital_city_selected != null)
          this.thong_tin_chung.hopitalCity = "" + this.hopital_city_selected.id;
        else this.thong_tin_chung.hopitalCity = null;
        //#region Add Line Manager
        this.employee_group.employeeid = this.thong_tin_chung.id;
        this.thong_tin_chung.employeeGroup = this.employee_group;
        //#endregion
        axios
          .put("/api/employee", this.thong_tin_chung)
          .then((res) => {
            this.$emit("update", this.thong_tin_chung);
            this.$toast.success("Update successful!", "Success", {
              timeout: 2000,
            });
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },
    updateThongTinLienHe() {
      if (this.hokhau_tinhthanhpho_selected != null)
        this.thong_tin_lien_he.hokhau_tinhthanhpho =
          "" + this.hokhau_tinhthanhpho_selected.id;
      if (this.hokhau_quanhuyen_selected != null)
        this.thong_tin_lien_he.hokhau_quanhuyen =
          "" + this.hokhau_quanhuyen_selected.id;
      if (this.hokhau_xaphuong_selected != null)
        this.thong_tin_lien_he.hokhau_xaphuong =
          "" + this.hokhau_xaphuong_selected.id;

      if (this.hiennay_tinhthanhpho_selected != null)
        this.thong_tin_lien_he.hiennay_tinhthanhpho =
          "" + this.hiennay_tinhthanhpho_selected.id;
      if (this.hiennay_quanhuyen_selected != null)
        this.thong_tin_lien_he.hiennay_quanhuyen =
          "" + this.hiennay_quanhuyen_selected.id;
      if (this.hiennay_xaphuong_selected != null)
        this.thong_tin_lien_he.hiennay_xaphuong =
          "" + this.hiennay_xaphuong_selected.id;

      if (this.cbx_hien_nay_giong_ho_khau)
        this.thong_tin_lien_he.hiennay_tinhthanhpho = "copy";

      axios
        .put("/api/employeecontact", this.thong_tin_lien_he)
        .then((res) => {
          this.$toast.success("Update successful!", "Success", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err + "", "Error", { timeout: 3000 });
        });
    },

    //#region line manager
    CheckCCEmail(ccemail) {
      var reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var ccemail_arr = ccemail.split(",");
      var ccemail_err = "";
      ccemail_arr.forEach((element) => {
        if (!reg_email.test(element)) ccemail_err += element + ", ";
      });
      return ccemail_err.trim().trim(",");
    },
    findLineManager(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? null : temp;
    },
    unlockLineManager(linemanager) {
      this.linemanager_selected = null;
      // this.employee_group.ccemail = "hr@megroup.asia";
      this.ccEmailEnabled = true;
    },
    lockLineManager() {
      this.linemanager_selected = null;
      // this.employee_group.ccemail = null;
      this.ccEmailEnabled = false;
    },
    //#endregion

    //#region hopital city
    unlockHopitalCity(city) {
      this.hopital_city_selected = null;
      this.thong_tin_chung.hopitalBranch = null;
      this.hopitalBranchEnabled = true;
    },
    lockHopitalCity() {
      this.hopital_city_selected = null;
      this.hopitalBranchEnabled = false;
    },
    //#endregion

    //#region Ho khau
    unlockDistrict(city) {
      this.hokhau_quanhuyen_selected = null;

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {
          this.districts = res.data;
          this.districtEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    unlockWard(district) {
      this.hokhau_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {
          this.wards = res.data;
          this.wardEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    lockDistrictAndWard() {
      this.hokhau_quanhuyen_selected = null;
      this.hokhau_xaphuong_selected = null;
      this.districtEnabled = false;
      this.wardEnabled = false;
    },

    lockWard() {
      this.hokhau_xaphuong_selected = null;
      this.wardEnabled = false;
    },
    //#endregion

    //#region dia chi hien nay
    unlockDistrict_hiennay(city) {
      this.hiennay_quanhuyen_selected = null;
      this.lockWard_hiennay();

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {
          this.hiennay_districts = res.data;
          this.hiennay_districtEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    unlockWard_hiennay(district) {
      this.hiennay_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {
          this.hiennay_wards = res.data;
          this.hiennay_wardEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    lockDistrictAndWard_hiennay() {
      this.hiennay_quanhuyen_selected = null;
      this.hiennay_xaphuong_selected = null;
      this.hiennay_districtEnabled = false;
      this.hiennay_wardEnabled = false;
    },

    lockWard_hiennay() {
      this.hiennay_xaphuong_selected = null;
      this.hiennay_wardEnabled = false;
    },
    //#endregion

    copySlot() {
      if (!this.cbx_hien_nay_giong_ho_khau) {
        this.hiennay_tinhthanhpho_selected = this.hokhau_tinhthanhpho_selected;
        this.hiennay_quanhuyen_selected = this.hokhau_quanhuyen_selected;
        this.hiennay_xaphuong_selected = this.hokhau_xaphuong_selected;
        this.thong_tin_lien_he.hiennay_sonha = this.thong_tin_lien_he.hokhau_sonha;
      } else {
        this.hiennay_tinhthanhpho_selected = null;
        this.hiennay_quanhuyen_selected = null;
        this.hiennay_xaphuong_selected = null;
        this.thong_tin_lien_he.hiennay_sonha = null;
      }
    },

    openFamilyModal() {
      this.gia_dinh_item = JSON.parse(JSON.stringify(this.gia_dinh_new));
      this.gia_dinh_item.employeeid = this.item.id;
      this.modalFamilyShow = true;
    },
    openUpdateFamilyModal(data) {
      this.gia_dinh_item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalFamilyShow = true;
    },
    closeFamilyModal() {
      this.modalFamilyShow = false;
    },
    storeFamilyItem(bvModalEvt) {
      if (
        !(this.gia_dinh_item.hovaten && this.gia_dinh_item.hovaten.length) ||
        !(this.gia_dinh_item.quanhe && this.gia_dinh_item.quanhe > 0)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin!", "Error", {
          //Please enter complete information!
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.gia_dinh_item.namsinh && this.gia_dinh_item.namsinh.length) {
          this.gia_dinh_item.namsinh = parseInt(this.gia_dinh_item.namsinh);
        }
        if (this.gia_dinh_item.id <= 0) {
          axios
            .post("/api/employeefamily", this.gia_dinh_item)
            .then((res) => {
              this.modalFamilyShow = false;
              this.items.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/employeefamily", this.gia_dinh_item)
            .then((res) => {
              this.modalFamilyShow = false;
              this.items[this.itemIdex] = JSON.parse(
                JSON.stringify(this.gia_dinh_item)
              );
              const temp = JSON.parse(JSON.stringify(this.items));
              this.items = JSON.parse(JSON.stringify(temp));
              this.itemIdex = null;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        }
      }
    },
    deleteFamilyItem(data) {
      this.$toast.question("Do you really want to delete?", "Remind", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeefamily/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successful!", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    trangthaiChange() {
      if (this.thong_tin_chung.tinhtranghoso == this.$tinhtranghoso_nghiviec) {
        this.nghiviecdate_show = true;
        this.$toast.warning("The contract will be Inactivated!", "Warning", {
          timeout: 3000,
        });
      } else {
        this.nghiviecdate_show = false;
        this.ngaynghiviec_selected = "";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}

.file-uploads.file-uploads-html4 input,
.file-uploads.file-uploads-html5 label {
  background: #fff;
  opacity: 0;
  font-size: 20em;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}

.file-uploads.file-uploads-html4 label,
.file-uploads.file-uploads-html5 input {
  background: rgba(255, 255, 255, 0);
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
</style>
